import React from 'react'
import './all.sass'
import Settings from "../templates/settings"

const TemplateWrapper = (props) => <Settings { ...props } />

export default TemplateWrapper
